import { Bot, Clock, FileText, Image, Mic, Tag, Type, Video } from "lucide-react";
import type { FluxoBlockType } from "@/hooks/useFluxos";

interface BlockMeta {
  /** Fallback em pt-BR; a chave vence quando o componente resolve. */
  label: string;
  labelKey: string;
  icon: React.ReactNode;
}

// Constante de modulo: avaliada no import, antes do idioma da conta ser conhecido.
// Por isso carrega a chave em vez de chamar t().
export const BLOCK_META: Record<FluxoBlockType, BlockMeta> = {
  texto: { label: "Texto", labelKey: "flow.blockText", icon: <Type size={16} /> },
  imagem: { label: "Imagem", labelKey: "flow.blockImage", icon: <Image size={16} /> },
  video: { label: "Vídeo", labelKey: "flow.blockVideo", icon: <Video size={16} /> },
  arquivo: { label: "Arquivo", labelKey: "flow.blockFile", icon: <FileText size={16} /> },
  audio: { label: "Áudio", labelKey: "flow.blockAudio", icon: <Mic size={16} /> },
  delay: { label: "Delay", labelKey: "flow.blockDelay", icon: <Clock size={16} /> },
  assistente: { label: "Ativar Assistente", labelKey: "flow.blockAssistant", icon: <Bot size={16} /> },
  tag: { label: "Adicionar Tag", labelKey: "flow.blockTag", icon: <Tag size={16} /> },
};

export const BLOCK_TYPES: FluxoBlockType[] = [
  "texto",
  "imagem",
  "video",
  "arquivo",
  "audio",
  "delay",
  "assistente",
  "tag",
];
